import { NavLink } from 'react-router-dom';

const navItems = [
  { title: 'Dashboard', path: '/admin', end: true, icon: '' },
  { title: 'Products', path: '/admin/products', icon: '' },
  { title: 'Categories', path: '/admin/categories', icon: '' },
  { title: 'Hero Slides', path: '/admin/hero-slides', icon: '' },
  { title: 'Combos', path: '/admin/combos', icon: '' },
  { title: 'Consultants', path: '/admin/consultants', icon: '' },
  { title: 'Orders', path: '/admin/orders', icon: '' },
  { title: 'Coupons', path: '/admin/coupons', icon: '' },
  { title: 'Contact', path: '/admin/contact', icon: '' },
  { title: 'Legal Pages', path: '/admin/legal-pages', icon: '' },
  { title: 'Users', path: '/admin/users', icon: '' },
];

export default function Sidebar({ isOpen = false, onNavigate }) {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/logo.png" alt="RealAyurveda Logo" className="logo-image" height={40} width={40} />
        </div>
        <div>
          <p className="sidebar-brand">RealAyurveda</p>
          <p className="sidebar-sub">Admin Panel</p>
        </div>
      </div>
      <nav className="sidebar-nav">
        <p className="sidebar-label">Management</p>
        <ul>
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.end}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onNavigate}
              >
                <span className="sidebar-link-icon">{item.icon}</span>
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <p>RealAyurveda Wellness Admin</p>
      </div>
    </aside>
  );
}
